(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(51463);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 15457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* reexport */ Slider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/autoplay/autoplay.min.css
var autoplay_min = __webpack_require__(65519);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./src/components/landingV4/common/Slider/Slider.module.scss
var Slider_module = __webpack_require__(97329);
var Slider_module_default = /*#__PURE__*/__webpack_require__.n(Slider_module);
;// CONCATENATED MODULE: ./src/components/landingV4/common/Slider/Slider.tsx







// eslint-disable-next-line import/no-unresolved

// eslint-disable-next-line import/no-unresolved

// eslint-disable-next-line import/no-unresolved


var Slider = function(param) {
    var items = param.items, _spaceBetween = param.spaceBetween, spaceBetween = _spaceBetween === void 0 ? 20 : _spaceBetween, _slidesPerView = param.slidesPerView, slidesPerView = _slidesPerView === void 0 ? 1 : _slidesPerView, breakpoints = param.breakpoints, _loop = param.loop, loop = _loop === void 0 ? false : _loop, _autoplay = param.autoplay, autoplay = _autoplay === void 0 ? false : _autoplay, _navigation = param.navigation, navigation = _navigation === void 0 ? false : _navigation, _className = param.className, className = _className === void 0 ? "" : _className;
    var swiperRef = (0,react.useRef)(null);
    var ref = (0,react.useState)({
        prev: true,
        next: false
    }), navDisabled = ref[0], setNavDisabled = ref[1];
    var syncNav = (0,react.useCallback)(function(swiper) {
        if (!navigation) return;
        if (swiper.isLocked) {
            setNavDisabled({
                prev: true,
                next: true
            });
            return;
        }
        if (loop) {
            setNavDisabled({
                prev: false,
                next: false
            });
            return;
        }
        setNavDisabled({
            prev: swiper.isBeginning,
            next: swiper.isEnd
        });
    }, [
        navigation,
        loop
    ]);
    var _id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((Slider_module_default()).sliderWrapper, navigation && (Slider_module_default()).sliderWrapperWithNav),
        children: [
            navigation && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (0,clsx_m/* default */.Z)((Slider_module_default()).navBtn, (Slider_module_default()).navPrev),
                        disabled: navDisabled.prev,
                        "aria-label": "Previous slide",
                        onClick: function() {
                            var ref;
                            return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slidePrev();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            "aria-hidden": true,
                            children: "‹"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (0,clsx_m/* default */.Z)((Slider_module_default()).navBtn, (Slider_module_default()).navNext),
                        disabled: navDisabled.next,
                        "aria-label": "Next slide",
                        onClick: function() {
                            var ref;
                            return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slideNext();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            "aria-hidden": true,
                            children: "›"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: (0,clsx_m/* default */.Z)((Slider_module_default()).root, className),
                modules: [
                    swiper_esm/* Pagination */.tl,
                    swiper_esm/* Autoplay */.pt
                ],
                pagination: {
                    clickable: true
                },
                onSwiper: function(swiper) {
                    swiperRef.current = swiper;
                    syncNav(swiper);
                },
                onSlideChange: function(swiper) {
                    return syncNav(swiper);
                },
                onBreakpoint: function(swiper) {
                    return syncNav(swiper);
                },
                onResize: function(swiper) {
                    return syncNav(swiper);
                },
                spaceBetween: spaceBetween,
                slidesPerView: slidesPerView,
                breakpoints: breakpoints,
                loop: loop
            }, autoplay && {
                autoplay: {
                    delay: 5000,
                    pauseOnMouseEnter: true,
                    disableOnInteraction: false
                }
            }), {
                children: items.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: item.content
                    }, (_id = item.id) !== null && _id !== void 0 ? _id : index);
                })
            }))
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/common/Slider/index.ts



/***/ }),

/***/ 51463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/constants/sections.ts
var sections = __webpack_require__(6872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/landingV4/common/AnimatedArrowPair/AnimatedArrowPair.module.scss
var AnimatedArrowPair_module = __webpack_require__(99996);
var AnimatedArrowPair_module_default = /*#__PURE__*/__webpack_require__.n(AnimatedArrowPair_module);
;// CONCATENATED MODULE: ./src/components/landingV4/common/AnimatedArrowPair/AnimatedArrowPair.tsx


var AnimatedArrowPair = function(param) {
    var iconIn = param.iconIn, iconOut = param.iconOut, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "".concat((AnimatedArrowPair_module_default()).wrapper, " ").concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (AnimatedArrowPair_module_default()).base,
                children: iconIn
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (AnimatedArrowPair_module_default()).hover,
                children: iconOut
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/common/AnimatedArrowPair/index.ts


// EXTERNAL MODULE: ./src/components/landingV4/common/Flex/index.ts + 1 modules
var Flex = __webpack_require__(75487);
// EXTERNAL MODULE: ./src/components/landingV4/common/Text/index.ts + 1 modules
var Text = __webpack_require__(50576);
// EXTERNAL MODULE: ./src/components/landingV4/common/Box/Box.module.scss
var Box_module = __webpack_require__(79673);
var Box_module_default = /*#__PURE__*/__webpack_require__.n(Box_module);
;// CONCATENATED MODULE: ./src/components/landingV4/common/Box/Box.tsx









var Box = function(props) {
    var className = props.className, iconIn = props.iconIn, iconOut = props.iconOut, icon = props.icon, iconSize = props.iconSize, title = props.title, description = props.description, children = props.children, rest = (0,_object_without_properties/* default */.Z)(props, [
        "className",
        "iconIn",
        "iconOut",
        "icon",
        "iconSize",
        "title",
        "description",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,clsx_m/* default */.Z)((Box_module_default()).root, className)
    }, rest), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Box_module_default()).content,
            children: [
                iconIn && iconOut && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Box_module_default()).animatedIconWrapper,
                    style: {
                        "--icon-size": iconSize
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedArrowPair, {
                        iconIn: iconIn,
                        iconOut: iconOut
                    })
                }),
                icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Box_module_default()).iconWrapper,
                    style: {
                        "--icon-size": iconSize
                    },
                    children: icon
                }),
                children,
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                    direction: "column",
                    gap: 2,
                    className: (Box_module_default()).textWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            type: "h3",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            type: "body16",
                            color: "white50",
                            className: (Box_module_default()).description,
                            children: description
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/landingV4/common/Box/index.ts


// EXTERNAL MODULE: ./src/components/landingV4/common/Container/index.ts + 1 modules
var Container = __webpack_require__(67306);
// EXTERNAL MODULE: ./src/components/landingV4/common/Link/index.ts + 1 modules
var Link = __webpack_require__(43602);
// EXTERNAL MODULE: ./src/components/landingV4/SolutionPage/solutionPagesData.ts + 7 modules
var solutionPagesData = __webpack_require__(85671);
// EXTERNAL MODULE: ./src/components/landingV4/BusinessModelsBlock/BusinessModelsBlock.module.scss
var BusinessModelsBlock_module = __webpack_require__(59962);
var BusinessModelsBlock_module_default = /*#__PURE__*/__webpack_require__.n(BusinessModelsBlock_module);
;// CONCATENATED MODULE: ./src/components/landingV4/BusinessModelsBlock/BusinessModelsBlock.tsx









var BusinessModelsBlock = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        id: sections/* SECTIONS_IDS.solutions */.s.solutions,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
            direction: "column",
            gap: 4,
            className: (BusinessModelsBlock_module_default()).root,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                    direction: "column",
                    gap: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            type: "h2",
                            children: "Built for modern business models"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            type: "body16",
                            color: "white50",
                            children: "Whether you’re a merchant, marketplace, or financial institution — tailor payments to your needs"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (BusinessModelsBlock_module_default()).grid,
                    children: solutionPagesData/* solutionPages.map */.Oz.map(function(param) {
                        var slug = param.slug, _card = param.card, title = _card.title, description = _card.description, Icon = _card.Icon;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            href: "/solutions/".concat(slug),
                            className: (BusinessModelsBlock_module_default()).cardLink,
                            "aria-label": "".concat(title, ": open solution"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {}),
                                iconSize: "40px",
                                title: title,
                                description: description,
                                className: (BusinessModelsBlock_module_default()).cardStretch
                            })
                        }, slug);
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/BusinessModelsBlock/index.ts


// EXTERNAL MODULE: ./src/components/landingV4/FAQBlock/index.ts + 1 modules
var FAQBlock = __webpack_require__(51580);
// EXTERNAL MODULE: ./src/components/landingV4/FeedbackBlock/index.ts + 27 modules
var FeedbackBlock = __webpack_require__(52898);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/hooks/use-lk-base-path.ts
var use_lk_base_path = __webpack_require__(14620);
// EXTERNAL MODULE: ./src/components/landingV4/common/ButtonLink/index.ts + 1 modules
var ButtonLink = __webpack_require__(64791);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/components/landingV4/common/CursorFollower/CursorFollower.module.scss
var CursorFollower_module = __webpack_require__(99268);
var CursorFollower_module_default = /*#__PURE__*/__webpack_require__.n(CursorFollower_module);
;// CONCATENATED MODULE: ./src/components/landingV4/common/CursorFollower/CursorFollower.tsx






var CursorFollower = function(param) {
    var children = param.children;
    var wrapperRef = (0,react.useRef)(null);
    var followerRef = (0,react.useRef)(null);
    var trailRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var lastMousePos = (0,react.useRef)({
        x: 0,
        y: 0
    });
    var isVisibleRef = (0,react.useRef)(false);
    var targetPos = (0,react.useRef)({
        x: 0,
        y: 0
    });
    var followerPos = (0,react.useRef)({
        x: 0,
        y: 0
    });
    var trailPos = (0,react.useRef)({
        x: 0,
        y: 0
    });
    var animationFrameRef = (0,react.useRef)(null);
    var syncElements = function() {
        if (followerRef.current) {
            followerRef.current.style.transform = "translate3d(".concat(followerPos.current.x, "px, ").concat(followerPos.current.y, "px, 0) translate(-50%, -50%)");
        }
        if (trailRef.current) {
            trailRef.current.style.transform = "translate3d(".concat(trailPos.current.x, "px, ").concat(trailPos.current.y, "px, 0) translate(-50%, -50%)");
        }
    };
    (0,react.useEffect)(function() {
        var wrapper = wrapperRef.current;
        if (!wrapper) return;
        var hideTimeout = null;
        var updateTargetPosition = function() {
            var rect = wrapper.getBoundingClientRect();
            targetPos.current = {
                x: lastMousePos.current.x - rect.left,
                y: lastMousePos.current.y - rect.top
            };
        };
        var animate = function() {
            followerPos.current = {
                x: followerPos.current.x + (targetPos.current.x - followerPos.current.x) * 0.2,
                y: followerPos.current.y + (targetPos.current.y - followerPos.current.y) * 0.2
            };
            trailPos.current = {
                x: trailPos.current.x + (followerPos.current.x - trailPos.current.x) * 0.12,
                y: trailPos.current.y + (followerPos.current.y - trailPos.current.y) * 0.12
            };
            syncElements();
            animationFrameRef.current = requestAnimationFrame(animate);
        };
        var startAnimation = function() {
            if (animationFrameRef.current !== null) return;
            animationFrameRef.current = requestAnimationFrame(animate);
        };
        var stopAnimation = function() {
            if (animationFrameRef.current === null) return;
            cancelAnimationFrame(animationFrameRef.current);
            animationFrameRef.current = null;
        };
        var handleMouseMove = function(e) {
            lastMousePos.current = {
                x: e.clientX,
                y: e.clientY
            };
            updateTargetPosition();
        };
        var handleMouseEnter = function(e) {
            if (hideTimeout) clearTimeout(hideTimeout);
            lastMousePos.current = {
                x: e.clientX,
                y: e.clientY
            };
            updateTargetPosition();
            followerPos.current = (0,_object_spread/* default */.Z)({}, targetPos.current);
            trailPos.current = (0,_object_spread/* default */.Z)({}, targetPos.current);
            syncElements();
            setIsVisible(true);
            startAnimation();
        };
        var handleMouseLeave = function() {
            hideTimeout = setTimeout(function() {
                setIsVisible(false);
                stopAnimation();
            }, 120);
        };
        var handleScroll = function() {
            if (!isVisibleRef.current) return;
            updateTargetPosition();
        };
        wrapper.addEventListener("mousemove", handleMouseMove);
        wrapper.addEventListener("mouseenter", handleMouseEnter);
        wrapper.addEventListener("mouseleave", handleMouseLeave);
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return function() {
            wrapper.removeEventListener("mousemove", handleMouseMove);
            wrapper.removeEventListener("mouseenter", handleMouseEnter);
            wrapper.removeEventListener("mouseleave", handleMouseLeave);
            window.removeEventListener("scroll", handleScroll);
            if (hideTimeout) clearTimeout(hideTimeout);
            stopAnimation();
        };
    }, []);
    (0,react.useEffect)(function() {
        isVisibleRef.current = isVisible;
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: wrapperRef,
        className: (CursorFollower_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: trailRef,
                className: (0,clsx_m/* default */.Z)((CursorFollower_module_default()).cursorTrail, (0,_define_property/* default */.Z)({}, (CursorFollower_module_default()).visible, isVisible))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: followerRef,
                className: (0,clsx_m/* default */.Z)((CursorFollower_module_default()).cursorFollower, (0,_define_property/* default */.Z)({}, (CursorFollower_module_default()).visible, isVisible))
            }),
            children
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/common/CursorFollower/index.ts


// EXTERNAL MODULE: ./src/components/landingV4/common/Slider/index.ts + 1 modules
var Slider = __webpack_require__(15457);
// EXTERNAL MODULE: ./src/components/landingV4/FirstScreen/FirstScreen.module.scss
var FirstScreen_module = __webpack_require__(93183);
var FirstScreen_module_default = /*#__PURE__*/__webpack_require__.n(FirstScreen_module);
;// CONCATENATED MODULE: ./src/components/landingV4/FirstScreen/FirstScreen.tsx












var FirstScreen = function() {
    var lkBasePath = (0,use_lk_base_path/* useLkBasePath */.v)();
    var slides = [
        {
            id: "routing-engine",
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FirstScreen_module_default()).slideImage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/assets/routing_engine_v4.png",
                    alt: "routing_engine",
                    width: 600,
                    height: 315,
                    layout: "responsive",
                    sizes: "(min-width: 960px) 66vw, 100vw"
                })
            })
        },
        {
            id: "dashboard",
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FirstScreen_module_default()).videoContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                    src: "/videos/dashboard.mp4",
                    controls: false,
                    autoPlay: true,
                    loop: true,
                    muted: true,
                    playsInline: true,
                    className: (FirstScreen_module_default()).video
                })
            })
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CursorFollower, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: (FirstScreen_module_default()).root,
            id: sections/* SECTIONS_IDS.first */.s.first,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                    type: "h1",
                    className: (0,clsx_m/* default */.Z)((FirstScreen_module_default()).title, (FirstScreen_module_default()).fadeInUp, (FirstScreen_module_default()).fadeInUpDelay1),
                    children: [
                        "One platform to accept, route ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                            className: (FirstScreen_module_default()).titleBreak
                        }),
                        " and settle payments worldwide"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (FirstScreen_module_default()).grid,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                            direction: "column",
                            className: (FirstScreen_module_default()).main,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                    type: "body16",
                                    color: "white50",
                                    className: (0,clsx_m/* default */.Z)((FirstScreen_module_default()).description, (FirstScreen_module_default()).fadeInUp, (FirstScreen_module_default()).fadeInUpDelay2),
                                    children: [
                                        "Connect to multiple acquirers and payment methods via a single integration",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "Get clear reporting, smart routing and enterprise-grade security from day one"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                    direction: "column",
                                    gap: 4,
                                    className: (0,clsx_m/* default */.Z)((FirstScreen_module_default()).fadeInUp, (FirstScreen_module_default()).fadeInUpDelay3),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* ButtonLink */.Z, {
                                            href: "".concat(lkBasePath, "/registration"),
                                            isOutsideLink: true,
                                            children: "Become a merchant"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* ButtonLink */.Z, {
                                            href: "#".concat(sections/* SECTIONS_IDS.contact */.s.contact),
                                            variant: "secondary",
                                            children: "Request demo"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* Slider */.i, {
                            items: slides,
                            autoplay: true,
                            className: (0,clsx_m/* default */.Z)((FirstScreen_module_default()).slider, (FirstScreen_module_default()).fadeInUp, (FirstScreen_module_default()).fadeInUpDelay4)
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/FirstScreen/index.ts


// EXTERNAL MODULE: ./src/components/landingV4/Footer/index.ts + 1 modules
var Footer = __webpack_require__(60830);
// EXTERNAL MODULE: ./src/components/landingV4/Header/index.ts + 8 modules
var Header = __webpack_require__(13906);
;// CONCATENATED MODULE: ./src/components/icons/ArrowsIntegration1V4Icon.tsx

var ArrowsIntegration1V4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 65 65",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M65 35H35V65",
                stroke: "#FFDD00",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 31V1H31",
                stroke: "#FFDD00",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/icons/ArrowsIntegration2V4Icon.tsx

var ArrowsIntegration2V4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 65 65",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M64 34V64H34",
                stroke: "#FFDD00",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 30H30V0",
                stroke: "#FFDD00",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/icons/ArrowsIntegration3V4Icon.tsx

var ArrowsIntegration3V4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 65 65",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 35H30V65",
                stroke: "#FFDD00",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M64 31V1H34",
                stroke: "#FFDD00",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/icons/ArrowsIntegration4V4Icon.tsx

var ArrowsIntegration4V4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 65 65",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 34V64H31",
                stroke: "#FFDD00",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M65 30H35V0",
                stroke: "#FFDD00",
                strokeWidth: "2"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/landingV4/PaymentsBlock/components/IntegrationSection/IntegrationSection.module.scss
var IntegrationSection_module = __webpack_require__(45523);
var IntegrationSection_module_default = /*#__PURE__*/__webpack_require__.n(IntegrationSection_module);
;// CONCATENATED MODULE: ./src/components/landingV4/PaymentsBlock/components/IntegrationSection/IntegrationSection.tsx











var IntegrationSection = function() {
    var lkBasePath = (0,use_lk_base_path/* useLkBasePath */.v)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
        direction: "column",
        gap: 4,
        className: (IntegrationSection_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                direction: "column",
                gap: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                        type: "h2",
                        children: [
                            "Accept payments globally — ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " with a single integration"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        type: "body16",
                        color: "white50",
                        className: (IntegrationSection_module_default()).description,
                        children: "Launch fast, expand to new markets, and keep full visibility across providers, methods, and currencies"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (IntegrationSection_module_default()).grid,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
                        iconIn: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsIntegration1V4Icon, {}),
                        iconOut: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsIntegration4V4Icon, {}),
                        title: "Add methods without reworking core integration",
                        description: "Cards / Wallets / Bank transfers APMs / Instant rails"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
                        iconIn: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsIntegration2V4Icon, {}),
                        iconOut: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsIntegration3V4Icon, {}),
                        title: "Payments worldwide",
                        description: "Process in the regions your customers actually pay from"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
                        iconIn: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsIntegration3V4Icon, {}),
                        iconOut: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsIntegration2V4Icon, {}),
                        title: "Clear operational view for support, finance, risk teams",
                        description: "Consolidated information on wallets, statistics and gates for the selected time period"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
                        iconIn: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsIntegration4V4Icon, {}),
                        iconOut: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsIntegration1V4Icon, {}),
                        title: "One consistent API layer across multiple integrations",
                        description: "No new API per provider — standard objects, webhooks, and idempotency"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* ButtonLink */.Z, {
                href: "".concat(lkBasePath, "/registration"),
                isOutsideLink: true,
                children: "Start processing"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/PaymentsBlock/components/IntegrationSection/index.ts


;// CONCATENATED MODULE: ./src/components/icons/ArrowsPayments1V4Icon.tsx

var ArrowsPayments1V4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M64 34H34V64",
                stroke: "#FFDD00",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.11759e-07 30H30V4.32134e-07",
                stroke: "#FFDD00",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/icons/ArrowsPayments2V4Icon.tsx

var ArrowsPayments2V4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 66 66",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M65 35V65H35",
                stroke: "#FFDD00",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 31V1H31",
                stroke: "#FFDD00",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/icons/ArrowsPayments3V4Icon.tsx

var ArrowsPayments3V4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 66 66",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 35V65H31",
                stroke: "#FFDD00",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M65 31V1H35",
                stroke: "#FFDD00",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/icons/ArrowsPayments4V4Icon.tsx

var ArrowsPayments4V4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 34H30V64",
                stroke: "#FFDD00",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M64 30H34V0",
                stroke: "#FFDD00",
                strokeWidth: "2"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/landingV4/PaymentsBlock/components/ProcessorSection/ProcessorSection.module.scss
var ProcessorSection_module = __webpack_require__(96729);
var ProcessorSection_module_default = /*#__PURE__*/__webpack_require__.n(ProcessorSection_module);
;// CONCATENATED MODULE: ./src/components/landingV4/PaymentsBlock/components/ProcessorSection/ProcessorSection.tsx











var ProcessorSection = function() {
    var lkBasePath = (0,use_lk_base_path/* useLkBasePath */.v)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
        direction: "column",
        gap: 4,
        className: (ProcessorSection_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProcessorSection_module_default()).titleWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                    type: "h2",
                    children: [
                        "Everything you need in",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " a modern payment processor"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ProcessorSection_module_default()).grid,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
                        iconIn: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsPayments1V4Icon, {}),
                        iconOut: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsPayments2V4Icon, {}),
                        title: "Pay-ins (Online payments)",
                        description: "Accept cards, wallets, bank transfers and local methods with one integration"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
                        iconIn: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsPayments2V4Icon, {}),
                        iconOut: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsPayments1V4Icon, {}),
                        title: "Pay-outs (Mass payouts)",
                        description: "Send funds to customers, partners and workforce across key payout rails"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
                        iconIn: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsPayments3V4Icon, {}),
                        iconOut: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsPayments4V4Icon, {}),
                        title: "Add payment methods",
                        description: "Accept cards, wallets, bank transfers and local methods with one integration"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
                        iconIn: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsPayments4V4Icon, {}),
                        iconOut: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsPayments3V4Icon, {}),
                        title: "Checkout & Risk",
                        description: "Conversion-focused checkout flows and built-in risk controls"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* ButtonLink */.Z, {
                href: "".concat(lkBasePath, "/registration"),
                isOutsideLink: true,
                children: "Start processing"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/PaymentsBlock/components/ProcessorSection/index.ts


// EXTERNAL MODULE: ./src/components/landingV4/PaymentsBlock/PaymentsBlock.module.scss
var PaymentsBlock_module = __webpack_require__(32403);
var PaymentsBlock_module_default = /*#__PURE__*/__webpack_require__.n(PaymentsBlock_module);
;// CONCATENATED MODULE: ./src/components/landingV4/PaymentsBlock/PaymentsBlock.tsx











var REVENUE_ANALYTICS_IMAGE = {
    src: "/assets/revenue-analytics.png",
    alt: "Revenue & Analytics",
    width: 1024,
    height: 785
};
var MAP_IMAGE = {
    src: "/assets/map.png",
    alt: "Integrations",
    width: 1008,
    height: 664
};
var PaymentsBlock = function() {
    var rootRef = (0,react.useRef)(null);
    var ref = (0,react.useState)("payments"), activeImage = ref[0], setActiveImage = ref[1];
    var ref1 = (0,react.useState)(false), isFixed = ref1[0], setIsFixed = ref1[1];
    var slides = [
        {
            id: "ProcessorSection",
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProcessorSection, {})
        },
        {
            id: "IntegrationSection",
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(IntegrationSection, {})
        }, 
    ];
    (0,react.useEffect)(function() {
        if (!rootRef.current) return;
        var handleScroll = function() {
            var rootRect = rootRef.current.getBoundingClientRect();
            var viewportCenter = window.innerHeight / 2;
            var shouldFix = rootRect.top < (window.innerHeight - rootRect.height * 0.4) / 2 && rootRect.bottom > (window.innerHeight - rootRect.height / 2) / 2 + rootRect.height / 2;
            setIsFixed(shouldFix);
            var isBlockInViewport = rootRect.top < window.innerHeight && rootRect.bottom > 0;
            if (isBlockInViewport) {
                var blockTop = rootRect.top;
                var blockHeight = rootRect.height;
                var relativePos = viewportCenter - blockTop;
                var neutralZoneRatio = 0.2;
                var neutralZoneHeight = blockHeight * neutralZoneRatio;
                var neutralStart = (blockHeight - neutralZoneHeight) / 2;
                var neutralEnd = neutralStart + neutralZoneHeight;
                if (relativePos < neutralStart) {
                    setActiveImage("payments");
                } else if (relativePos > neutralEnd) {
                    setActiveImage("integrations");
                } else {
                    setActiveImage("");
                }
            }
        };
        window.addEventListener("scroll", handleScroll);
        handleScroll();
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
        id: sections/* SECTIONS_IDS.products */.s.products,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (PaymentsBlock_module_default()).root,
                ref: rootRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                        direction: "column",
                        gap: 40,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProcessorSection, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IntegrationSection, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PaymentsBlock_module_default()).rightSection,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,clsx_m/* default */.Z)((PaymentsBlock_module_default()).gifWrapper, isFixed && (PaymentsBlock_module_default()).fixed, activeImage === "payments" && (PaymentsBlock_module_default()).processor, activeImage === "integrations" && (PaymentsBlock_module_default()).integrations),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)((PaymentsBlock_module_default()).gif, (PaymentsBlock_module_default()).revenueAnalytics, activeImage === "payments" && (PaymentsBlock_module_default()).visible),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: REVENUE_ANALYTICS_IMAGE.src,
                                        alt: REVENUE_ANALYTICS_IMAGE.alt,
                                        layout: "fill",
                                        objectFit: "contain",
                                        objectPosition: "left top",
                                        sizes: "(max-width: 959px) 320px, 560px"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)((PaymentsBlock_module_default()).gif, (PaymentsBlock_module_default()).map, activeImage === "integrations" && (PaymentsBlock_module_default()).visible),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: MAP_IMAGE.src,
                                        alt: MAP_IMAGE.alt,
                                        layout: "fill",
                                        objectFit: "contain",
                                        objectPosition: "left top",
                                        sizes: "(max-width: 959px) 483px, 584px"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PaymentsBlock_module_default()).mobileRoot,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                    direction: "column",
                    gap: 40,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)((PaymentsBlock_module_default()).gif, (PaymentsBlock_module_default()).revenueAnalytics),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: REVENUE_ANALYTICS_IMAGE.src,
                                alt: REVENUE_ANALYTICS_IMAGE.alt,
                                layout: "fill",
                                objectFit: "contain",
                                sizes: "(max-width: 959px) 320px, 560px"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (PaymentsBlock_module_default()).slider,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* Slider */.i, {
                                items: slides
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (PaymentsBlock_module_default()).gifWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)((PaymentsBlock_module_default()).gif, (PaymentsBlock_module_default()).map),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: MAP_IMAGE.src,
                                    alt: MAP_IMAGE.alt,
                                    layout: "fill",
                                    objectFit: "contain",
                                    sizes: "(max-width: 959px) 483px, 584px"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/PaymentsBlock/index.ts


;// CONCATENATED MODULE: ./src/components/icons/Card32V4Icon.tsx

var Card32V4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6 5.75C4.61929 5.75 3.5 6.86929 3.5 8.25V8.875H27.5V8.25C27.5 6.86929 26.3807 5.75 25 5.75H6ZM3.5 21.25V12.625H27.5V21.25C27.5 22.6307 26.3807 23.75 25 23.75H6C4.61929 23.75 3.5 22.6307 3.5 21.25ZM1.5 8.25C1.5 5.76472 3.51472 3.75 6 3.75H25C27.4853 3.75 29.5 5.76472 29.5 8.25V21.25C29.5 23.7353 27.4853 25.75 25 25.75H6C3.51472 25.75 1.5 23.7353 1.5 21.25V8.25ZM7.5 15.625C6.46447 15.625 5.625 16.4645 5.625 17.5V18.75C5.625 19.7855 6.46447 20.625 7.5 20.625H10.5C11.5355 20.625 12.375 19.7855 12.375 18.75V17.5C12.375 16.4645 11.5355 15.625 10.5 15.625H7.5Z",
            fill: "#00FFBB"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/icons/EnterV4Icon.tsx

var EnterV4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13 5.75C12.6022 5.75 12.2206 5.90804 11.9393 6.18934C11.658 6.47064 11.5 6.85218 11.5 7.25V9.75C11.5 10.3023 11.0523 10.75 10.5 10.75C9.94772 10.75 9.5 10.3023 9.5 9.75V7.25C9.5 6.32174 9.86875 5.4315 10.5251 4.77513C11.1815 4.11875 12.0717 3.75 13 3.75H26C26.9283 3.75 27.8185 4.11875 28.4749 4.77513C29.1313 5.4315 29.5 6.32174 29.5 7.25V22.25C29.5 23.1783 29.1313 24.0685 28.4749 24.7249C27.8185 25.3813 26.9283 25.75 26 25.75H13C12.0717 25.75 11.1815 25.3813 10.5251 24.7249C9.86875 24.0685 9.5 23.1783 9.5 22.25V19.75C9.5 19.1977 9.94772 18.75 10.5 18.75C11.0523 18.75 11.5 19.1977 11.5 19.75V22.25C11.5 22.6478 11.658 23.0294 11.9393 23.3107C12.2206 23.592 12.6022 23.75 13 23.75H26C26.3978 23.75 26.7794 23.592 27.0607 23.3107C27.342 23.0294 27.5 22.6478 27.5 22.25V7.25C27.5 6.85218 27.342 6.47064 27.0607 6.18934C26.7794 5.90804 26.3978 5.75 26 5.75H13ZM15.7929 9.04289C16.1834 8.65237 16.8166 8.65237 17.2071 9.04289L22.2071 14.0429C22.5976 14.4334 22.5976 15.0666 22.2071 15.4571L17.2071 20.4571C16.8166 20.8476 16.1834 20.8476 15.7929 20.4571C15.4024 20.0666 15.4024 19.4334 15.7929 19.0429L19.0858 15.75H2.5C1.94772 15.75 1.5 15.3023 1.5 14.75C1.5 14.1977 1.94772 13.75 2.5 13.75H19.0858L15.7929 10.4571C15.4024 10.0666 15.4024 9.43342 15.7929 9.04289Z",
            fill: "#00FFBB"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/icons/LocationV4Icon.tsx

var LocationV4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.5 11.0625C4.5 5.73833 9.02638 1.5 14.5 1.5C19.9736 1.5 24.5 5.73833 24.5 11.0625C24.5 14.064 22.8771 17.7776 21.0994 20.9874C19.295 24.2453 17.217 27.1804 16.1026 28.6854C15.9187 28.9368 15.6783 29.1414 15.4007 29.2827C15.1217 29.4247 14.813 29.4987 14.5 29.4987C14.187 29.4987 13.8783 29.4247 13.5993 29.2827C13.3217 29.1414 13.0812 28.9367 12.8973 28.6853C11.783 27.1798 9.70497 24.2435 7.90058 20.9852C6.12292 17.7752 4.5 14.0619 4.5 11.0625ZM14.5 3.5C10.0361 3.5 6.5 6.93542 6.5 11.0625C6.5 13.5006 7.87708 16.8145 9.65021 20.0163C11.3918 23.1613 13.4091 26.0146 14.5 27.4889C15.5908 26.0153 17.6082 23.163 19.3498 20.0184C21.1229 16.8171 22.5 13.5028 22.5 11.0625C22.5 6.93542 18.9639 3.5 14.5 3.5Z",
                fill: "#00FFBB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.5 9.5C13.3954 9.5 12.5 10.3954 12.5 11.5C12.5 12.6046 13.3954 13.5 14.5 13.5C15.6046 13.5 16.5 12.6046 16.5 11.5C16.5 10.3954 15.6046 9.5 14.5 9.5ZM10.5 11.5C10.5 9.29086 12.2909 7.5 14.5 7.5C16.7091 7.5 18.5 9.29086 18.5 11.5C18.5 13.7091 16.7091 15.5 14.5 15.5C12.2909 15.5 10.5 13.7091 10.5 11.5Z",
                fill: "#00FFBB"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/icons/SwapHorizontalV4Icon.tsx

var SwapHorizontalV4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.2929 2.29289C18.6834 1.90237 19.3166 1.90237 19.7071 2.29289L26.7071 9.29289C27.0976 9.68342 27.0976 10.3166 26.7071 10.7071L19.7071 17.7071C19.3166 18.0976 18.6834 18.0976 18.2929 17.7071C17.9024 17.3166 17.9024 16.6834 18.2929 16.2929L23.5858 11H6C5.44772 11 5 10.5523 5 10C5 9.44772 5.44772 9 6 9H23.5858L18.2929 3.70711C17.9024 3.31658 17.9024 2.68342 18.2929 2.29289ZM13.7071 14.2929C14.0976 14.6834 14.0976 15.3166 13.7071 15.7071L8.41421 21H26C26.5523 21 27 21.4477 27 22C27 22.5523 26.5523 23 26 23H8.41421L13.7071 28.2929C14.0976 28.6834 14.0976 29.3166 13.7071 29.7071C13.3166 30.0976 12.6834 30.0976 12.2929 29.7071L5.29289 22.7071C4.90237 22.3166 4.90237 21.6834 5.29289 21.2929L12.2929 14.2929C12.6834 13.9024 13.3166 13.9024 13.7071 14.2929Z",
            fill: "#00FFBB"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/icons/WalletV4Icon.tsx

var WalletV4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.3229 2.32199C21.916 2.21049 22.5264 2.23049 23.1111 2.38063C23.699 2.53163 24.2464 2.81053 24.7142 3.19743C25.1819 3.58433 25.5585 4.0697 25.8171 4.61891C26.0756 5.16812 26.2098 5.76762 26.21 6.37465V6.37497V7.31282C28.0804 7.64788 29.5 9.28316 29.5 11.25V23.25C29.5 25.4591 27.7091 27.25 25.5 27.25H5.5C3.29086 27.25 1.5 25.4591 1.5 23.25V11.25L1.5 11.2476V9.18777V9.18747C1.49951 8.2272 1.83406 7.29683 2.44598 6.55676C3.05806 5.81652 3.90927 5.31308 4.8528 5.13327C4.85911 5.13207 4.86543 5.13093 4.87175 5.12985L21.3229 2.32199ZM24.21 6.37529V7.25H5.5C5.16121 7.25 4.83227 7.29212 4.51811 7.3714C4.73208 7.24083 4.96902 7.14819 5.21866 7.09956L21.6682 4.29197C21.6716 4.2914 21.6749 4.29081 21.6782 4.29021C21.6812 4.28967 21.6842 4.28911 21.6872 4.28854C21.9944 4.23 22.3107 4.23998 22.6136 4.31777C22.9165 4.39555 23.1985 4.53923 23.4394 4.73854C23.6804 4.93786 23.8744 5.1879 24.0076 5.47082C24.1407 5.75365 24.2099 6.06237 24.21 6.37497V6.37529ZM3.5 23.25L3.5 12.25V11.248C3.50107 10.1444 4.39609 9.25 5.5 9.25H25.5C26.6046 9.25 27.5 10.1454 27.5 11.25V23.25C27.5 24.3546 26.6046 25.25 25.5 25.25H5.5C4.39543 25.25 3.5 24.3546 3.5 23.25ZM21.3889 18.9129C21.7178 19.1327 22.1044 19.25 22.5 19.25C23.0304 19.25 23.5391 19.0393 23.9142 18.6642C24.2893 18.2891 24.5 17.7804 24.5 17.25C24.5 16.8544 24.3827 16.4678 24.1629 16.1389C23.9432 15.81 23.6308 15.5536 23.2654 15.4022C22.8999 15.2509 22.4978 15.2113 22.1098 15.2884C21.7219 15.3656 21.3655 15.5561 21.0858 15.8358C20.8061 16.1155 20.6156 16.4719 20.5384 16.8598C20.4613 17.2478 20.5009 17.6499 20.6522 18.0154C20.8036 18.3808 21.06 18.6932 21.3889 18.9129Z",
            fill: "#00FFBB"
        })
    });
};

// EXTERNAL MODULE: ./src/components/landingV4/PayoutsBlock/components/PayoutsDemoForm/PayoutsDemoForm.module.scss
var PayoutsDemoForm_module = __webpack_require__(4894);
var PayoutsDemoForm_module_default = /*#__PURE__*/__webpack_require__.n(PayoutsDemoForm_module);
;// CONCATENATED MODULE: ./src/components/landingV4/PayoutsBlock/components/PayoutsDemoForm/PayoutsDemoForm.tsx





var PayoutsDemoForm = function(props) {
    var className = props.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
        className: (0,clsx_m/* default */.Z)((PayoutsDemoForm_module_default()).root, className),
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
            className: (PayoutsDemoForm_module_default()).form,
            direction: "column",
            gap: 6,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    type: "medium18",
                    color: "white",
                    children: "Payment"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                    direction: "column",
                    gap: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            className: (PayoutsDemoForm_module_default()).label,
                            children: "Wallet 1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                            className: (PayoutsDemoForm_module_default()).input,
                            alignItems: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                type: "medium18",
                                color: "white",
                                children: "555 555.00"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                    direction: "column",
                    gap: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            className: (PayoutsDemoForm_module_default()).label,
                            children: "Total"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                            className: (PayoutsDemoForm_module_default()).input,
                            alignItems: "center"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                    className: (PayoutsDemoForm_module_default()).button,
                    alignItems: "center",
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        type: "medium18",
                        color: "green",
                        children: "Pay"
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/PayoutsBlock/components/PayoutsDemoForm/index.ts


// EXTERNAL MODULE: ./src/components/landingV4/PayoutsBlock/PayoutsBlock.module.scss
var PayoutsBlock_module = __webpack_require__(46383);
var PayoutsBlock_module_default = /*#__PURE__*/__webpack_require__.n(PayoutsBlock_module);
;// CONCATENATED MODULE: ./src/components/landingV4/PayoutsBlock/PayoutsBlock.tsx












var PAYOUT_OPTIONS = [
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapHorizontalV4Icon, {}),
        title: "Bank transfer"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card32V4Icon, {}),
        title: "Cards"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(WalletV4Icon, {}),
        title: "Wallets"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(EnterV4Icon, {}),
        title: "Instant payments"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationV4Icon, {}),
        title: "Local rails"
    }, 
];
var PayoutsBlock = function(props) {
    var className = props.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        className: (0,clsx_m/* default */.Z)((PayoutsBlock_module_default()).root, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (PayoutsBlock_module_default()).grid,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                    className: (PayoutsBlock_module_default()).info,
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                            direction: "column",
                            gap: 4,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                    type: "h2",
                                    children: [
                                        "Fast, predictable settlements",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "— and flexible payouts"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                    type: "regular16",
                                    color: "white50",
                                    children: [
                                        "Manage settlement cycles, balances,",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "and outgoing payments from one place"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                            className: (PayoutsBlock_module_default()).payoutOptions,
                            direction: "column",
                            gap: 6,
                            children: PAYOUT_OPTIONS.map(function(param, index) {
                                var icon = param.icon, title = param.title;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                    gap: 6,
                                    alignItems: "center",
                                    children: [
                                        icon,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            type: "medium18",
                                            color: "white",
                                            children: title
                                        })
                                    ]
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            type: "regular16",
                            color: "white50",
                            children: "Send payouts to customers, partners, and workforce"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PayoutsDemoForm, {
                    className: (PayoutsBlock_module_default()).form
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/PayoutsBlock/index.ts


;// CONCATENATED MODULE: ./src/components/icons/ArrowsProtect1InV4Icon.tsx

var ArrowsProtect1InV4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30 33L30 63L0 63",
                stroke: "#FFDD00",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M63 31V1H33",
                stroke: "#FFDD00",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/icons/ArrowsProtect1OutV4Icon.tsx

var ArrowsProtect1OutV4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31 34L1 34L1 64",
                stroke: "#FFDD00",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M64 30H34V0",
                stroke: "#FFDD00",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/icons/ArrowsProtect2InV4Icon.tsx

var ArrowsProtect2InV4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33 34H63V64",
                stroke: "#FFDD00",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31 1L1 1L1 31",
                stroke: "#FFDD00",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/icons/ArrowsProtect2OutV4Icon.tsx

var ArrowsProtect2OutV4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34 33V63H64",
                stroke: "#FFDD00",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30 0L30 30L0 30",
                stroke: "#FFDD00",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/icons/ArrowsProtect3InV4Icon.tsx

var ArrowsProtect3InV4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 33V63H31",
                stroke: "#FFDD00",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M63 0V30L33 30",
                stroke: "#FFDD00",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/icons/ArrowsProtect3OutV4Icon.tsx

var ArrowsProtect3OutV4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 34H30V64",
                stroke: "#FFDD00",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M64 1L34 1V31",
                stroke: "#FFDD00",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/icons/ArrowsProtect4InV4Icon.tsx

var ArrowsProtect4InV4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34 0V30H64",
                stroke: "#FFDD00",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30 33L30 63H0",
                stroke: "#FFDD00",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/icons/ArrowsProtect4OutV4Icon.tsx

var ArrowsProtect4OutV4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33 1L63 1V31",
                stroke: "#FFDD00",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31 34H1L1 64",
                stroke: "#FFDD00",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/icons/ArrowsProtect5InV4Icon.tsx

var ArrowsProtect5InV4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33 34H63V64",
                stroke: "#FFDD00",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 0L1 30L31 30",
                stroke: "#FFDD00",
                strokeWidth: "2"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/icons/ArrowsProtect5OutV4Icon.tsx

var ArrowsProtect5OutV4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 64 66",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33 35V65H63",
                stroke: "#FFDD00",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 1L31 1L31 31",
                stroke: "#FFDD00",
                strokeWidth: "2"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/landingV4/ProtectBlock/ProtectBlock.module.scss
var ProtectBlock_module = __webpack_require__(62007);
var ProtectBlock_module_default = /*#__PURE__*/__webpack_require__.n(ProtectBlock_module);
;// CONCATENATED MODULE: ./src/components/landingV4/ProtectBlock/ProtectBlock.tsx




















var ProtectBlock = function() {
    var lkBasePath = (0,use_lk_base_path/* useLkBasePath */.v)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        id: sections/* SECTIONS_IDS.resources */.s.resources,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ProtectBlock_module_default()).root,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                    direction: "column",
                    gap: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            type: "h2",
                            children: "Operate with clarity — protect revenue by design"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ProtectBlock_module_default()).grid,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
                                    iconIn: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsProtect1InV4Icon, {}),
                                    iconOut: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsProtect1OutV4Icon, {}),
                                    title: "Reporting & Analytics",
                                    description: "Unified reporting across methods, providers, entities, and time zones"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
                                    iconIn: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsProtect2InV4Icon, {}),
                                    iconOut: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsProtect2OutV4Icon, {}),
                                    title: "Anti-fraud",
                                    description: "Risk rules, velocity checks, 3DS flows (if applicable), anomaly signals"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
                                    iconIn: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsProtect3InV4Icon, {}),
                                    iconOut: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsProtect3OutV4Icon, {}),
                                    title: "Reconciliation",
                                    description: "Match transactions, fees, settlements, and payouts. Export to accounting systems"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
                                    iconIn: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsProtect4InV4Icon, {}),
                                    iconOut: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsProtect4OutV4Icon, {}),
                                    title: "Security & Compliance",
                                    description: "PCI-ready approach, encryption, secure key handling, audit logs"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
                                    iconIn: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsProtect5InV4Icon, {}),
                                    iconOut: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsProtect5OutV4Icon, {}),
                                    title: "Settings & RBAC",
                                    description: "Granular permissions per team: finance, support, risk, developers"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* ButtonLink */.Z, {
                            href: "".concat(lkBasePath, "/registration"),
                            isOutsideLink: true,
                            children: "Start processing"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                    justifyContent: "center",
                    alignItems: "center",
                    className: (ProtectBlock_module_default()).rightSection,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ProtectBlock_module_default()).gif,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/assets/sales-chart.png",
                            alt: "Sales chart",
                            width: 388,
                            height: 374,
                            layout: "responsive",
                            sizes: "(min-width: 960px) 388px, 0px"
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/ProtectBlock/index.ts


// EXTERNAL MODULE: ./src/components/landingV4/ScaleBlock/ScaleBlock.module.scss
var ScaleBlock_module = __webpack_require__(28805);
var ScaleBlock_module_default = /*#__PURE__*/__webpack_require__.n(ScaleBlock_module);
;// CONCATENATED MODULE: ./src/components/landingV4/ScaleBlock/ScaleBlock.tsx









var ScaleBlock = function() {
    var cascadingBox = /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
        className: (ScaleBlock_module_default()).card,
        title: "Cascading / Smart routing",
        description: "Automatically route transactions across providers based on rules: region, cost, approval rate, limits and risk signals",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (ScaleBlock_module_default()).gif,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "/assets/scale1-v4.png",
                alt: "Cascading / Smart routing",
                width: 1116,
                height: 602,
                layout: "responsive",
                sizes: "(min-width: 1280px) 50vw, 100vw"
            })
        })
    });
    var FXBox = /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
        className: (ScaleBlock_module_default()).card,
        title: "FX / Currency conversion",
        description: "Handle multi-currency pricing and settlement logic with configurable conversion flows",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (ScaleBlock_module_default()).gif,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "/assets/scale2-v4.png",
                alt: "FX / Currency conversion",
                width: 1116,
                height: 602,
                layout: "responsive",
                sizes: "(min-width: 1280px) 50vw, 100vw"
            })
        })
    });
    var slides = [
        {
            id: "CascadingBox",
            content: cascadingBox
        },
        {
            id: "FXBox",
            content: FXBox
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
        className: (ScaleBlock_module_default()).root,
        id: sections/* SECTIONS_IDS.developers */.s.developers,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                direction: "column",
                gap: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        type: "h2",
                        children: "Scale to new markets — without rebuilding your payments stack"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        type: "body16",
                        children: "Add providers, routes, methods, and currencies through orchestration — while keeping one control plane"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ScaleBlock_module_default()).grid,
                children: [
                    cascadingBox,
                    FXBox
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ScaleBlock_module_default()).slider,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* Slider */.i, {
                    items: slides
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/ScaleBlock/index.ts


// EXTERNAL MODULE: ./src/components/landingV4/SnackbarProvider/index.ts + 4 modules
var SnackbarProvider = __webpack_require__(7513);
// EXTERNAL MODULE: ./src/components/layout/MainLayout/EmptyLayout.tsx
var EmptyLayout = __webpack_require__(46615);
;// CONCATENATED MODULE: ./src/pages/index.tsx














var Page = function() {
    // Remove when v4 is fully released
    (0,react.useLayoutEffect)(function() {
        document.documentElement.classList.add("v4");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SnackbarProvider/* SnackbarProvider */.w, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstScreen, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsBlock, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessModelsBlock, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScaleBlock, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PayoutsBlock, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProtectBlock, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQBlock/* FAQBlock */.C, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeedbackBlock/* FeedbackBlock */.O, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* Footer */.$, {})
        ]
    });
};
Page.getLayout = function(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyLayout/* EmptyLayout */.T, {
        withFloatMenu: false,
        children: page
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (Page);


/***/ }),

/***/ 59962:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"BusinessModelsBlock_root__Sa6f_","grid":"BusinessModelsBlock_grid__lpc8I","cardLink":"BusinessModelsBlock_cardLink__OsR7S","cardStretch":"BusinessModelsBlock_cardStretch__KKHnb"};

/***/ }),

/***/ 93183:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"FirstScreen_root__V7XOS","title":"FirstScreen_title__SLP73","titleBreak":"FirstScreen_titleBreak__7i_dn","description":"FirstScreen_description__aOiKE","grid":"FirstScreen_grid__UcTGy","main":"FirstScreen_main__nsBqA","slider":"FirstScreen_slider__1DKCh","slideImage":"FirstScreen_slideImage__joylT","videoContainer":"FirstScreen_videoContainer__Doe1H","video":"FirstScreen_video__GaI95","fadeInUp":"FirstScreen_fadeInUp__SSq_L","fadeInUpDelay1":"FirstScreen_fadeInUpDelay1__b_uaz","fadeInUpDelay2":"FirstScreen_fadeInUpDelay2__1IYKe","fadeInUpDelay3":"FirstScreen_fadeInUpDelay3__t5GAS","fadeInUpDelay4":"FirstScreen_fadeInUpDelay4__gqnIs"};

/***/ }),

/***/ 32403:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsBlock_root__2FKFS","mobileRoot":"PaymentsBlock_mobileRoot__ZvQWX","slider":"PaymentsBlock_slider__idXBI","rightSection":"PaymentsBlock_rightSection__H2Gu8","gifWrapper":"PaymentsBlock_gifWrapper__7Mndt","processor":"PaymentsBlock_processor__TQO5d","integrations":"PaymentsBlock_integrations__vBlXm","fixed":"PaymentsBlock_fixed__WS635","gif":"PaymentsBlock_gif__uK0DS","revenueAnalytics":"PaymentsBlock_revenueAnalytics__8Tgy9","map":"PaymentsBlock_map__JMET9","visible":"PaymentsBlock_visible__HDekw"};

/***/ }),

/***/ 45523:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"IntegrationSection_root__HPnhK","description":"IntegrationSection_description__rDJt9","grid":"IntegrationSection_grid__DYEUX","gif":"IntegrationSection_gif__Co964"};

/***/ }),

/***/ 96729:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcessorSection_root__NDl0f","grid":"ProcessorSection_grid__Rk7vB","gif":"ProcessorSection_gif__nLf95"};

/***/ }),

/***/ 46383:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"PayoutsBlock_root__Zlb1O","grid":"PayoutsBlock_grid__xhGND","info":"PayoutsBlock_info__IqbZV","payoutOptions":"PayoutsBlock_payoutOptions___M2Gi","form":"PayoutsBlock_form__FlFUS"};

/***/ }),

/***/ 4894:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"PayoutsDemoForm_root__mL8HQ","form":"PayoutsDemoForm_form__7i0EY","label":"PayoutsDemoForm_label__cu41G","input":"PayoutsDemoForm_input__S5X8l","button":"PayoutsDemoForm_button__wthHu"};

/***/ }),

/***/ 62007:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"ProtectBlock_root__X0LOw","grid":"ProtectBlock_grid__ZtjaG","rightSection":"ProtectBlock_rightSection__KnpG4","gif":"ProtectBlock_gif__qqlDJ"};

/***/ }),

/***/ 28805:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"ScaleBlock_root__Hv69u","grid":"ScaleBlock_grid__oZWqR","card":"ScaleBlock_card__p8Rdn","gif":"ScaleBlock_gif__vlq81","slider":"ScaleBlock_slider__NNQW8"};

/***/ }),

/***/ 99996:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AnimatedArrowPair_wrapper__q0bic","base":"AnimatedArrowPair_base__aMH34","hover":"AnimatedArrowPair_hover__r2BDc"};

/***/ }),

/***/ 79673:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"Box_root__PMLWj","content":"Box_content__WDAkc","animatedIconWrapper":"Box_animatedIconWrapper__7Fxih","iconWrapper":"Box_iconWrapper__BIN_N","textWrapper":"Box_textWrapper__m_wX5","description":"Box_description__g8jIu"};

/***/ }),

/***/ 99268:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CursorFollower_wrapper__xiiTR","cursorFollower":"CursorFollower_cursorFollower__R71dF","cursorTrail":"CursorFollower_cursorTrail__YRjFH","visible":"CursorFollower_visible__bqNEv"};

/***/ }),

/***/ 97329:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"Slider_sliderWrapper__gyBqO","sliderWrapperWithNav":"Slider_sliderWrapperWithNav__iMiw4","navBtn":"Slider_navBtn__AJ7FU","navPrev":"Slider_navPrev__mNsFU","navNext":"Slider_navNext___sm1Q","root":"Slider_root__qGRsc"};

/***/ }),

/***/ 65519:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 68770:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [536,522,928,366,834,168,671,879,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);